import React from 'react';
import { Button } from '@material-ui/core'
import { makeStyles  } from '@material-ui/core/styles';
import IntlMessages from 'util/IntlMessages';

const useStyles = makeStyles((theme) => ({
  saveBtn: {
      // padding: '5px 15px',
      // background: 'rgb(92,209,209)',
      background: 'linear-gradient(45deg, #0c969c, #0EACB3)',
      // fontWeight: '500',
      color: '#ffffff',
      '&:hover' :{
        filter: 'brightness(1.1)',
      },
      '&:disabled, &[disabled]' :{
        background: '#CFCFCF',
      }
  }

}));

function SaveBtn(props) {

    const classes = useStyles();

    return (
        <Button 
            size="small"
            className={classes.saveBtn}
            variant="contained"
            onClick={props.sendThisState}
            disabled={!props.isEnabled}
            >
               <IntlMessages id="Save" />
        </Button>
    );
}

export default SaveBtn;